import { useParams } from 'react-router-dom';

import { useGetUserSubscriptionsQuery } from 'state/userAdminSlices';

export function useSubscription(
  explicitSubscriptionId?: string,
  explicitProjectId?: string,
) {
  const { sub_id, project_id } = useParams();
  const { currentData: subscriptionData } = useGetUserSubscriptionsQuery();
  const subscriptions = subscriptionData?.subscriptions;
  const subscriptionId = explicitSubscriptionId ?? sub_id;
  const subscription =
    !subscriptionId || !subscriptionData
      ? null
      : (subscriptions.find(
          (item) => item.subscription_id === subscriptionId,
        ) ?? null);

  const projectId = explicitProjectId ?? project_id;
  const project_data =
    subscription && projectId !== null
      ? (subscription.projects.find((item) => item?.project_id === projectId) ??
        null)
      : null;

  return { subscription, project_data };
}
